import { useState } from "react";

import {
    PlayerInfoOverlayProps,
} from "./models";

import "./style.scss";

import { Box, Stack } from "@mui/material";
import { Close } from "@mui/icons-material";
import { Star } from "@mui/icons-material";
import { Recommend } from "@mui/icons-material";

import { Redirect, useHistory, useLocation } from "react-router-dom";

interface LocationState {

    from: {
        pathname: string;
    };
    comingFromDomain: boolean;
}

export const PlayerInfoOverlay = (props: PlayerInfoOverlayProps) => {

    const [redirectToHome, setRedirectToHome] = useState<boolean>(false);

    const history = useHistory();
    const location = useLocation<LocationState>();

    const [isFavorite, setIsFavorite] = useState<boolean>(props.isAlreadyFavorite);
    const [isLiked, setIsLiked] = useState<boolean>(props.isAlreadyLiked);

    const goToPreviousPage = () => {
        if (location.state !== undefined && location.state.comingFromDomain)
            history.goBack()
        else {
            setRedirectToHome(true)
        }
    }

    return (
        <>
            {redirectToHome && <Redirect to="/" />}
            < Box sx={{
                position: "absolute",
                zIndex: 9999,
                width: "100%",
                background:
                    "linear-gradient(180deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.35) 41%, rgba(133,133,133,0.20) 72%, rgba(255,255,255,0) 100%);",
            }}
                className={props.showInfoOverlay ? 'fadeIn' : 'fadeOut'}>
                <h1 style={{
                    color: "white",
                    textAlign: "center"
                }}>{props.contentName}</h1>

                <Stack
                    style={{
                        position: "absolute",
                        right: 30,
                        top: 13
                    }}
                    spacing={2}
                    display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    direction={"row"}>
                    {props.showActions && <>
                        <div onClick={() => { setIsFavorite(!isFavorite); props.setFavoriteCallbackFn() }}>
                            <Star className={!isFavorite ? "pio-action" : "pio-action-pressed"}
                                style={{
                                    fontSize: "2em",
                                    fontWeight: "bolder",
                                }} />
                        </div>
                        <div onClick={() => { setIsLiked(!isLiked); props.setLikeCallbackFn() }}>
                            <Recommend className={!isLiked ? "pio-action" : "pio-action-pressed"}
                                style={{
                                    fontSize: "2em",
                                    fontWeight: "bolder",
                                }} />
                        </div>
                    </>}
                    <div onClick={() => goToPreviousPage()}>
                        <Close className="pio-action" style={{
                            fontSize: "3.5em",
                            fontWeight: "bolder",
                        }} />
                    </div>
                </Stack>
            </Box>
        </>
    );
}